import dayjs from "dayjs";

/**
 * customParseFormat
 */
const customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);

/**
 * TimeZone
 */
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Localized Format
 */
const localizedFormat = require("dayjs/plugin/localizedFormat");
const localeData = require("dayjs/plugin/localeData");
dayjs.extend(localizedFormat);
dayjs.extend(localeData);

const dayjsIsSameOrBefore = require("dayjs/plugin/isSameOrBefore");
const dayjsIsSameOrAfter = require("dayjs/plugin/isSameOrAfter");
const objectSupport = require("dayjs/plugin/objectSupport");
const calendar = require("dayjs/plugin/calendar");
const isoWeek = require("dayjs/plugin/isoWeek");
const weekOfYear = require("dayjs/plugin/weekOfYear");
const weekYear = require("dayjs/plugin/weekYear");
const weekday = require("dayjs/plugin/weekday");
const relativeTime = require("dayjs/plugin/relativeTime");
const quarterOfYear = require("dayjs/plugin/quarterOfYear");
const minMax = require("dayjs/plugin/minMax");

dayjs.extend(objectSupport);
dayjs.extend(calendar);
dayjs.extend(isoWeek);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(weekday);
dayjs.extend(relativeTime);
dayjs.extend(quarterOfYear);
dayjs.extend(dayjsIsSameOrBefore);
dayjs.extend(dayjsIsSameOrAfter);
dayjs.extend(minMax);

export default dayjs;
